import { useEffect, useState } from 'react';

const timerCadenceMs = 1000;
const maxDriftMs = 10000;

/**
 *
 * @returns milliseconds diff from target (negative if in past)
 */
export const useTimerCounter = (target: Date, options?: { onNegative: () => void }): number => {
  const [msToTarget, setMsToTarget] = useState(target.getTime() - Date.now());
  const isNegative = msToTarget <= 0; // Yes, I am including zero

  useEffect(() => {
    const repeatingTimer = setInterval(() => {
      setMsToTarget((prevMillis) => {
        // This will cause a drift over time since timer fires at non-exact intervals
        const smoothUpdate = prevMillis - timerCadenceMs;
        const actualUpdate = target.getTime() - Date.now();
        const drift = Math.abs(smoothUpdate - actualUpdate);

        return drift < maxDriftMs ? smoothUpdate : actualUpdate;
      });
    }, timerCadenceMs);

    return () => clearInterval(repeatingTimer);
  }, []);

  // onNegative Runner
  useEffect(() => {
    if (isNegative && options?.onNegative) {
      options.onNegative();
    }
  }, [isNegative]);

  return msToTarget;
};
